/* eslint-disable quotes */
import BRAND from '@/forms/constants/brand';

// GENERIC CONSTANTS

const GENERIC_TITLE = 'Oops...';
const GENERIC_SUBTITLE = "It seems that this page is not what you're looking for";
const GENERIC_LOADING_MESSAGE = 'Give us a few seconds…';

const END_PAGE_OPS = GENERIC_TITLE;
const NOT_ELIGIBLE = 'NOT ELIGIBLE';
const ELIGIBLE = 'ELIGIBLE';
const CREDIT_NOT_APPROVED_TITLE = name => `Dear ${name},`;
const NOT_ELIGIBLE_MESSAGE = `Thank you for your application. We have assessed your request with great care,
and we believe that it is our responsibility to suggest that you first reduce your current debt. The
below listed companies can help you do so and it would be our pleasure to reassess your
application in the future.`;
const CREDIT_NOT_APPROVED_TITLE_SALES = (status, name) => `${status}! Dear ${name},`;
const NOT_ELIGIBLE_MESSAGE_SALES = (newProduct, cifNumber) => `Thank you for your application. Based on the information provided by you, it looks like the Deem
${newProduct} is not the best fit for you. Your customer identification number is ${cifNumber}.`;

const BASIC_NOT_ELIGIBLE = `Thank you for your application. Based on the information provided by you,
it looks like the Deem Loan is not the best fit for you.`;
// ${BRAND.loan}
const NO_MONTHLY_INSTALMENTS_FROM_SERVER = 'Something went wrong';
const TRANSACTION_NOT_STARTED = 'Transaction not started';
const END_FORM = 'end_form';

// DBR
const MIN_ALLOWED_DBR = 50;
const DBR_CARD_LIMIT_PERCENT = 5 / 100;

// AGE LOGIC CONSTANTS
const MIN_AGE = 21;
const MAX_AGE = 61;
const NOT_VALID_AGE_MESSAGE = "It seems that you're under age and, therefore, you are not allowed to contract our services.";
const MOBILE_NUMBER_FIELD_NAME = 'My phone number is';

// PATTERN CONSTANTS
const EMAIL_VALIDATION_PATTERN = '^[0-9a-zA-Z-._+]+@[0-9a-zA-Z]+([-.][0-9a-zA-Z]+)*([0-9a-zA-Z]*[.])[a-zA-Z]{2,12}$';
const DIGIT_CHARS = '^[0-9]*$';
const MOBILE_STARTING_NUMBER = '^5';
const MOBILE_NUMBER_LENGTH = '^[0-9]{9}$';
const MOBILE_NUMBER_LENGTH_GLOBAL = '^[0-9]{9,11}$';
const IBAN_NUMBER_LENGTH = '^[0-9]{21}$';
const CREDIT_CARD_NUMBER_LENGTH = '^[0-9]{16}$'
const NAMES_CHARS = '^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.\'-]+$';
const NAME_CHARS_SPACE = '^[a-zA-Z ]'
const ALPHA_NUMERIC = '^[a-zA-Z0-9]*$';
const CAPTCHA_LENGTH = '^[a-zA-Z0-9@!#$&*]{7}$';
const CAPTCHA_CHARS = '^[a-zA-Z0-9@!#$&*]*$';
const ADDRESS_CHARS = '^[a-zA-Z0-9 ,-/]*$';
const SUPPLEMENTARY_CHARS = '^[0-9]{3}$';
const SUPPLEMENTARY_LAST_DIGIT = '0^';
const SUPPLEMENTARY_FIRST_DIGIT = '^1';
//^(100|[1-9][0-9]?)$
const SUPPLEMENTARY_PERCENTAGE = '^(100|[1-9][0-9]?)$';
const IS_VALID_DATE = /(0\d{1}|1[0-2])\/([0-2]\d{1}|3[0-1])\/(19|20)(\d{2})/;
// EMIRATES ID LOGIC CONSTANTS
const EMIRATES_STARTING_NUMBER = '^784';
const EMIRATES_NUMBER_LENGTH = '^[0-9]{15}$';

// INCOME LOGIC CONSTANTS
const NOT_VALID_INCOME_MESSAGE = 'Looks like our Platinum card is not the best fit for you. Our team will contact you shortly to better understand your needs.';
const MIN_FIXED_INCOME_DSP = 4000;
const MIN_TOTAL_INCOME = 5000;
const MIN_FIXED_INCOME = 5000;
const MAX_ALLOWED = 9999999;
const MIN_ALLOWED = 0;
const MIN_TOTAL_INCOME_LOAN = 4000;

// OFFER APPOINTMENT LOGIC

const AT_MY_OFFICE = 'At my office';
const SOMEWHERE_ELSE = 'Somewhere else';
const APPOINTMENT_PLACE_OPTIONS = [{
        value: AT_MY_OFFICE,
        label: AT_MY_OFFICE,
    },
    {
        value: SOMEWHERE_ELSE,
        label: SOMEWHERE_ELSE,
    },
];

// DECISION SERVICE
const APPROVED = 'APPROVED';
const REJECTED = 'REJECTED';

const CONDITIONALLY_APPROVED = 'CONDITIONALLY APPROVED';
const TECHNICAL_ERROR = 'TECHNICAL ERROR';
const PROGRESS = 'PROGRESS'
    //const CONDITIONALLY_APPROVED = 'CONDITIONAL APPROVAL';
    //const REJECTED_BUREAU_SCORE='REJECTED BUREAU SCORE'

const DECISION_FORM_MAP = {
    'STP Card': {
        [APPROVED]: 'STP Card Offer',
        [REJECTED]: 'STP Card Rejected',
        [CONDITIONALLY_APPROVED]: 'STP Card Needs Review',
        [TECHNICAL_ERROR]: 'STP Card Technical Error'
    },
    'STP Loan': {
        [APPROVED]: 'STP Loan Offer',
        [REJECTED]: 'STP Loan Rejected',
        [CONDITIONALLY_APPROVED]: 'STP Loan Needs Review',
        [TECHNICAL_ERROR]: 'STP Loan Technical Error'
    },
    'STP Auto Loan': {
        [APPROVED]: 'Auto Loan Offer',
        [REJECTED]: 'Auto Loan Rejected',
        [CONDITIONALLY_APPROVED]: 'Auto Loan Needs Review',
        [TECHNICAL_ERROR]: 'Auto Loan Technical Error'
    },
    //STP TopUp
    'STP Top Up': {
        [APPROVED]: 'STP Top Up Offer',
        [REJECTED]: 'STP Top Up Rejected',
        [CONDITIONALLY_APPROVED]: 'STP Top Up Needs Review',
        [TECHNICAL_ERROR]: 'STP Top Up Technical Error'
    },
    'Deem | Credit Card Application': {
        [APPROVED]: 'Credit Card Offer',
        [REJECTED]: 'Credit Card Rejected',
        [CONDITIONALLY_APPROVED]: 'Credit Card Needs Review',
        [TECHNICAL_ERROR]: 'Credit Card Technical Error'
    },
    'Deem | Loan Application': {
        [APPROVED]: 'Loan offer',
        [REJECTED]: 'Loan rejected',
        [CONDITIONALLY_APPROVED]: 'Loan needs review',
        [TECHNICAL_ERROR]: 'Loan Technical Error'
    },
    //Aggregator
    'Deem | Credit Card Application | Aggregator': {
        [APPROVED]: 'Credit Card Offer | Aggregator',
        [REJECTED]: 'Credit Card Rejected | Aggregator',
        [CONDITIONALLY_APPROVED]: 'Credit Card Needs Review | Aggregator',
        [TECHNICAL_ERROR]: 'Credit Card Technical Error | Aggregator'
    },
    'Eid Card': {
        [APPROVED]: 'Eid Card Offer',
        [REJECTED]: 'Eid Card Rejected',
        [CONDITIONALLY_APPROVED]: 'Eid Card Needs Review',
        [TECHNICAL_ERROR]: 'Eid Card Technical Error'
    },

    'Deem | Onboarding Digital': {
        [PROGRESS]: 'Onboarding Digital | Progress',
        //     [APPROVED]: 'Onboarding Digital | Offer',
        //     [REJECTED]: 'Onboarding Digital | Rejected',
        //     [CONDITIONALLY_APPROVED]: 'Onboarding Digital | Offer',
        //     [TECHNICAL_ERROR]: 'Onboarding Digital | Technical Error'
    },
    'Onboarding Digital | Progress': {
        [APPROVED]: 'Onboarding Digital | Offer',
        [REJECTED]: 'Onboarding Digital | Rejected',
        [CONDITIONALLY_APPROVED]: 'Onboarding Digital | Offer',
        [TECHNICAL_ERROR]: 'Onboarding Digital | Technical Error'
    }
};

// DOUBLE SECURE

const NOMINEE_RELATIONSHIP_OPTIONS = [{
        label: 'Spouse',
        value: 'Spouse',
    },
    {
        label: 'Child over 18 years',
        value: 'Child over 18 years',
    },
    {
        label: 'Parent',
        value: 'Parent',
    },
    {
        label: 'Sibling',
        value: 'Sibling',
    },
    {
        label: 'Other',
        value: 'Other',
    },
];

// LONG VALUES
const COUNTRIESAPPOINTMENT = [
    { value: 'ARE', label: 'United Arab Emirates' },
]
const COUNTRIES = [
    { value: 'ABW', label: 'Aruba' },
    { value: 'AFG', label: 'Afghanistan' },
    { value: 'AGO', label: 'Angola' },
    { value: 'AIA', label: 'Anguilla' },
    { value: 'ALA', label: 'Åland Islands' },
    { value: 'ALB', label: 'Albania' },
    { value: 'AND', label: 'Andorra' },
    { value: 'ANT', label: 'Netherlands Antilles' },
    { value: 'ARE', label: 'United Arab Emirates' },
    { value: 'ARG', label: 'Argentina' },
    { value: 'ARM', label: 'Armenia' },
    { value: 'ASM', label: 'American Samoa' },
    { value: 'ATA', label: 'Antarctica' },
    { value: 'ATF', label: 'French Southern Territories' },
    { value: 'ATG', label: 'Antigua and Barbuda' },
    { value: 'AUS', label: 'Australia' },
    { value: 'AUT', label: 'Austria' },
    { value: 'AZE', label: 'Azerbaijan' },
    { value: 'BDI', label: 'Burundi' },
    { value: 'BEL', label: 'Belgium' },
    { value: 'BEN', label: 'Benin' },
    { value: 'BFA', label: 'Burkina Faso' },
    { value: 'BGD', label: 'Bangladesh' },
    { value: 'BGR', label: 'Bulgaria' },
    { value: 'BHR', label: 'Bahrain' },
    { value: 'BHS', label: 'Bahamas' },
    { value: 'BIH', label: 'Bosnia and Herzegovina' },
    { value: 'BLM', label: 'Saint Barthélemy' },
    { value: 'BLR', label: 'Belarus' },
    { value: 'BLZ', label: 'Belize' },
    { value: 'BMU', label: 'Bermuda' },
    { value: 'BOL', label: 'Bolivia, Plurinational State of' },
    { value: 'BRA', label: 'Brazil' },
    { value: 'BRB', label: 'Barbados' },
    { value: 'BRN', label: 'Brunei Darussalam' },
    { value: 'BTN', label: 'Bhutan' },
    { value: 'BVT', label: 'Bouvet Island' },
    { value: 'BWA', label: 'Botswana' },
    { value: 'CAF', label: 'Central African Republic' },
    { value: 'CAN', label: 'Canada' },
    { value: 'CCK', label: 'Cocos (Keeling) Islands' },
    { value: 'CHE', label: 'Switzerland' },
    { value: 'CHL', label: 'Chile' },
    { value: 'CHN', label: 'China' },
    { value: 'CIV', label: `Côte d'Ivoire` },
    { value: 'CMR', label: 'Cameroon' },
    { value: 'COD', label: 'Congo, the Democratic Republic of the' },
    { value: 'COG', label: 'Congo' },
    { value: 'COK', label: 'Cook Islands' },
    { value: 'COL', label: 'Colombia' },
    { value: 'COM', label: 'Comoros' },
    { value: 'CPV', label: 'Cape Verde' },
    { value: 'CRI', label: 'Costa Rica' },
    { value: 'CUB', label: 'Cuba' },
    { value: 'CXR', label: 'Christmas Island' },
    { value: 'CYM', label: 'Cayman Islands' },
    { value: 'CYP', label: 'Cyprus' },
    { value: 'CZE', label: 'Czech Republic' },
    { value: 'DEU', label: 'Germany' },
    { value: 'DJI', label: 'Djibouti' },
    { value: 'DMA', label: 'Dominica' },
    { value: 'DNK', label: 'Denmark' },
    { value: 'DOM', label: 'Dominican Republic' },
    { value: 'DZA', label: 'Algeria' },
    { value: 'ECU', label: 'Ecuador' },
    { value: 'EGY', label: 'Egypt' },
    { value: 'ERI', label: 'Eritrea' },
    { value: 'ESH', label: 'Western Sahara' },
    { value: 'ESP', label: 'Spain' },
    { value: 'EST', label: 'Estonia' },
    { value: 'ETH', label: 'Ethiopia' },
    { value: 'FIN', label: 'Finland' },
    { value: 'FJI', label: 'Fiji' },
    { value: 'FLK', label: 'Falkland Islands (Malvinas)' },
    { value: 'FRA', label: 'France' },
    { value: 'FRO', label: 'Faroe Islands' },
    { value: 'FSM', label: 'Micronesia, Federated States of' },
    { value: 'GAB', label: 'Gabon' },
    { value: 'GBR', label: 'United Kingdom' },
    { value: 'GEO', label: 'Georgia' },
    { value: 'GGY', label: 'Guernsey' },
    { value: 'GHA', label: 'Ghana' },
    { value: 'GIB', label: 'Gibraltar' },
    { value: 'GIN', label: 'Guinea' },
    { value: 'GLP', label: 'Guadeloupe' },
    { value: 'GMB', label: 'Gambia' },
    { value: 'GNB', label: 'Guinea-Bissau' },
    { value: 'GNQ', label: 'Equatorial Guinea' },
    { value: 'GRC', label: 'Greece' },
    { value: 'GRD', label: 'Grenada' },
    { value: 'GRL', label: 'Greenland' },
    { value: 'GTM', label: 'Guatemala' },
    { value: 'GUF', label: 'French Guiana' },
    { value: 'GUM', label: 'Guam' },
    { value: 'GUY', label: 'Guyana' },
    { value: 'HKG', label: 'Hong Kong' },
    { value: 'HMD', label: 'Heard Island and McDonald Islands' },
    { value: 'HND', label: 'Honduras' },
    { value: 'HRV', label: 'Croatia' },
    { value: 'HTI', label: 'Haiti' },
    { value: 'HUN', label: 'Hungary' },
    { value: 'IDN', label: 'Indonesia' },
    { value: 'IMN', label: 'Isle of Man' },
    { value: 'IND', label: 'India' },
    { value: 'IOT', label: 'British Indian Ocean Territory' },
    { value: 'IRL', label: 'Ireland' },
    { value: 'IRN', label: 'Iran, Islamic Republic of' },
    { value: 'IRQ', label: 'Iraq' },
    { value: 'ISL', label: 'Iceland' },
    { value: 'ISR', label: 'Israel' },
    { value: 'ITA', label: 'Italy' },
    { value: 'JAM', label: 'Jamaica' },
    { value: 'JEY', label: 'Jersey' },
    { value: 'JOR', label: 'Jordan' },
    { value: 'JPN', label: 'Japan' },
    { value: 'KAZ', label: 'Kazakhstan' },
    { value: 'KEN', label: 'Kenya' },
    { value: 'KGZ', label: 'Kyrgyzstan' },
    { value: 'KHM', label: 'Cambodia' },
    { value: 'KIR', label: 'Kiribati' },
    { value: 'KNA', label: 'Saint Kitts and Nevis' },
    { value: 'KOR', label: 'Korea, Republic of' },
    { value: 'KWT', label: 'Kuwait' },
    { value: 'LAO', label: `Lao People's Democratic Republic` },
    { value: 'LBN', label: 'Lebanon' },
    { value: 'LBR', label: 'Liberia' },
    { value: 'LBY', label: 'Libyan Arab Jamahiriya' },
    { value: 'LCA', label: 'Saint Lucia' },
    { value: 'LIE', label: 'Liechtenstein' },
    { value: 'LKA', label: 'Sri Lanka' },
    { value: 'LSO', label: 'Lesotho' },
    { value: 'LTU', label: 'Lithuania' },
    { value: 'LUX', label: 'Luxembourg' },
    { value: 'LVA', label: 'Latvia' },
    { value: 'MAC', label: 'Macao' },
    { value: 'MAF', label: 'Saint Martin (French part)' },
    { value: 'MAR', label: 'Morocco' },
    { value: 'MCO', label: 'Monaco' },
    { value: 'MDA', label: 'Moldova, Republic of' },
    { value: 'MDG', label: 'Madagascar' },
    { value: 'MDV', label: 'Maldives' },
    { value: 'MEX', label: 'Mexico' },
    { value: 'MHL', label: 'Marshall Islands' },
    { value: 'MKD', label: 'Macedonia, the former Yugoslav Republic of' },
    { value: 'MLI', label: 'Mali' },
    { value: 'MLT', label: 'Malta' },
    { value: 'MMR', label: 'Myanmar' },
    { value: 'MNE', label: 'Montenegro' },
    { value: 'MNG', label: 'Mongolia' },
    { value: 'MNP', label: 'Northern Mariana Islands' },
    { value: 'MOZ', label: 'Mozambique' },
    { value: 'MRT', label: 'Mauritania' },
    { value: 'MSR', label: 'Montserrat' },
    { value: 'MTQ', label: 'Martinique' },
    { value: 'MUS', label: 'Mauritius' },
    { value: 'MWI', label: 'Malawi' },
    { value: 'MYS', label: 'Malaysia' },
    { value: 'MYT', label: 'Mayotte' },
    { value: 'NAM', label: 'Namibia' },
    { value: 'NCL', label: 'New Caledonia' },
    { value: 'NER', label: 'Niger' },
    { value: 'NFK', label: 'Norfolk Island' },
    { value: 'NGA', label: 'Nigeria' },
    { value: 'NIC', label: 'Nicaragua' },
    { value: 'NIU', label: 'Niue' },
    { value: 'NLD', label: 'Netherlands' },
    { value: 'NOR', label: 'Norway' },
    { value: 'NPL', label: 'Nepal' },
    { value: 'NRU', label: 'Nauru' },
    { value: 'NZL', label: 'New Zealand' },
    { value: 'OMN', label: 'Oman' },
    { value: 'PAK', label: 'Pakistan' },
    { value: 'PAN', label: 'Panama' },
    { value: 'PCN', label: 'Pitcairn' },
    { value: 'PER', label: 'Peru' },
    { value: 'PHL', label: 'Philippines' },
    { value: 'PLW', label: 'Palau' },
    { value: 'PNG', label: 'Papua New Guinea' },
    { value: 'POL', label: 'Poland' },
    { value: 'PRI', label: 'Puerto Rico' },
    { value: 'PRK', label: `Korea, Democratic People's Republic of` },
    { value: 'PRT', label: 'Portugal' },
    { value: 'PRY', label: 'Paraguay' },
    { value: 'PSE', label: 'Palestinian Territory, Occupied' },
    { value: 'PYF', label: 'French Polynesia' },
    { value: 'QAT', label: 'Qatar' },
    { value: 'REU', label: 'Réunion' },
    { value: 'ROU', label: 'Romania' },
    { value: 'RUS', label: 'Russian Federation' },
    { value: 'RWA', label: 'Rwanda' },
    { value: 'SAU', label: 'Saudi Arabia' },
    { value: 'SDN', label: 'Sudan' },
    { value: 'SEN', label: 'Senegal' },
    { value: 'SGP', label: 'Singapore' },
    { value: 'SGS', label: 'South Georgia and the South Sandwich Islands' },
    { value: 'SHN', label: 'Saint Helena, Ascension and Tristan da Cunha' },
    { value: 'SJM', label: 'Svalbard and Jan Mayen' },
    { value: 'SLB', label: 'Solomon Islands' },
    { value: 'SLE', label: 'Sierra Leone' },
    { value: 'SLV', label: 'El Salvador' },
    { value: 'SMR', label: 'San Marino' },
    { value: 'SOM', label: 'Somalia' },
    { value: 'SPM', label: 'Saint Pierre and Miquelon' },
    { value: 'SRB', label: 'Serbia' },
    { value: 'STP', label: 'Sao Tome and Principe' },
    { value: 'SUR', label: 'Suriname' },
    { value: 'SVK', label: 'Slovakia' },
    { value: 'SVN', label: 'Slovenia' },
    { value: 'SWE', label: 'Sweden' },
    { value: 'SWZ', label: 'Swaziland' },
    { value: 'SYC', label: 'Seychelles' },
    { value: 'SYR', label: 'Syrian Arab Republic' },
    { value: 'TCA', label: 'Turks and Caicos Islands' },
    { value: 'TCD', label: 'Chad' },
    { value: 'TGO', label: 'Togo' },
    { value: 'THA', label: 'Thailand' },
    { value: 'TJK', label: 'Tajikistan' },
    { value: 'TKL', label: 'Tokelau' },
    { value: 'TKM', label: 'Turkmenistan' },
    { value: 'TLS', label: 'Timor-Leste' },
    { value: 'TON', label: 'Tonga' },
    { value: 'TTO', label: 'Trinidad and Tobago' },
    { value: 'TUN', label: 'Tunisia' },
    { value: 'TUR', label: 'Turkey' },
    { value: 'TUV', label: 'Tuvalu' },
    { value: 'TWN', label: 'Taiwan, Province of China' },
    { value: 'TZA', label: 'Tanzania, United Republic of' },
    { value: 'UGA', label: 'Uganda' },
    { value: 'UKR', label: 'Ukraine' },
    { value: 'UMI', label: 'United States Minor Outlying Islands' },
    { value: 'URY', label: 'Uruguay' },
    { value: 'USA', label: 'United States' },
    { value: 'UZB', label: 'Uzbekistan' },
    { value: 'VAT', label: 'Holy See (Vatican City State)' },
    { value: 'VCT', label: 'Saint Vincent and the Grenadines' },
    { value: 'VEN', label: 'Venezuela, Bolivarian Republic of' },
    { value: 'VGB', label: 'Virgin Islands, British' },
    { value: 'VIR', label: 'Virgin Islands, U.S.' },
    { value: 'VNM', label: 'Viet Nam' },
    { value: 'VUT', label: 'Vanuatu' },
    { value: 'WLF', label: 'Wallis and Futuna' },
    { value: 'WSM', label: 'Samoa' },
    { value: 'YEM', label: 'Yemen' },
    { value: 'ZAF', label: 'South Africa' },
    { value: 'ZMB', label: 'Zambia' },
    { value: 'ZWE', label: 'Zimbabwe' },


];
const COUNTRIES_HIGH_RISK = [
    'AFG',
    'BHS',
    'BWA',
    'KHM',
    'CUB',
    'COD',
    'GNQ',
    'GHA',
    'GNB',
    'ISL',
    'IRN',
    'ISR',
    'MMR',
    'MNG',
    'NGA',
    'PRK',
    'PAK',
    'PAN',
    'QAT',
    'SOM',
    'KNA',
    'SDN',
    'SYR',
    'TTO',
    'VEN',
    'YEM',
    'ZWE'
];
const COUNTRIES_PHONE_CODE = [{
        value: '+7 840',
        label: 'Abkhazia',
    },
    {
        value: '+93',
        label: 'Afghanistan',
    },
    {
        value: '+355',
        label: 'Albania',
    },
    {
        value: '+213',
        label: 'Algeria',
    },
    {
        value: '+1 684',
        label: 'American Samoa',
    },
    {
        value: '+376',
        label: 'Andorra',
    },
    {
        value: '+244',
        label: 'Angola',
    },
    {
        value: '+1 264',
        label: 'Anguilla',
    },
    {
        value: '+1 268',
        label: 'Antigua and Barbuda',
    },
    {
        value: '+54',
        label: 'Argentina',
    },
    {
        value: '+374',
        label: 'Armenia',
    },
    {
        value: '+297',
        label: 'Aruba',
    },
    {
        value: '+247',
        label: 'Ascension',
    },
    {
        value: '+61',
        label: 'Australia',
    },
    {
        value: '+672',
        label: 'Australian External Territories',
    },
    {
        value: '+43',
        label: 'Austria',
    },
    {
        value: '+994',
        label: 'Azerbaijan',
    },
    {
        value: '+1 242',
        label: 'Bahamas',
    },
    {
        value: '+973',
        label: 'Bahrain',
    },
    {
        value: '+880',
        label: 'Bangladesh',
    },
    {
        value: '+1 246',
        label: 'Barbados',
    },
    {
        value: '+375',
        label: 'Belarus',
    },
    {
        value: '+32',
        label: 'Belgium',
    },
    {
        value: '+501',
        label: 'Belize',
    },
    {
        value: '+229',
        label: 'Benin',
    },
    {
        value: '+1 441',
        label: 'Bermuda',
    },
    {
        value: '+975',
        label: 'Bhutan',
    },
    {
        value: '+591',
        label: 'Bolivia',
    },
    {
        value: '+387',
        label: 'Bosnia and Herzegovina',
    },
    {
        value: '+267',
        label: 'Botswana',
    },
    {
        value: '+55',
        label: 'Brazil',
    },
    {
        value: '+246',
        label: 'British Indian Ocean Territory',
    },
    {
        value: '+1 284',
        label: 'British Virgin Islands',
    },
    {
        value: '+673',
        label: 'Brunei',
    },
    {
        value: '+359',
        label: 'Bulgaria',
    },
    {
        value: '+226',
        label: 'Burkina Faso',
    },
    {
        value: '+257',
        label: 'Burundi',
    },
    {
        value: '+855',
        label: 'Cambodia',
    },
    {
        value: '+237',
        label: 'Cameroon',
    },
    {
        value: '+238',
        label: 'Cape Verde',
    },
    {
        value: '+ 345',
        label: 'Cayman Islands',
    },
    {
        value: '+236',
        label: 'Central African Republic',
    },
    {
        value: '+235',
        label: 'Chad',
    },
    {
        value: '+56',
        label: 'Chile',
    },
    {
        value: '+86',
        label: 'China',
    },
    {
        value: '+57',
        label: 'Colombia',
    },
    {
        value: '+269',
        label: 'Comoros',
    },
    {
        value: '+242',
        label: 'Congo',
    },
    {
        value: '+243',
        label: 'Congo, Dem. Rep. of (Zaire)',
    },
    {
        value: '+682',
        label: 'Cook Islands',
    },
    {
        value: '+506',
        label: 'Costa Rica',
    },
    {
        value: '+385',
        label: 'Croatia',
    },
    {
        value: '+53',
        label: 'Cuba',
    },
    {
        value: '+537',
        label: 'Cyprus',
    },
    {
        value: '+420',
        label: 'Czech Republic',
    },
    {
        value: '+45',
        label: 'Denmark',
    },
    {
        value: '+253',
        label: 'Djibouti',
    },
    {
        value: '+1 767',
        label: 'Dominica',
    },
    {
        value: '+1 809',
        label: 'Dominican Republic',
    },
    {
        value: '+593',
        label: 'Ecuador',
    },
    {
        value: '+20',
        label: 'Egypt',
    },
    {
        value: '+503',
        label: 'El Salvador',
    },
    {
        value: '+240',
        label: 'Equatorial Guinea',
    },
    {
        value: '+291',
        label: 'Eritrea',
    },
    {
        value: '+372',
        label: 'Estonia',
    },
    {
        value: '+251',
        label: 'Ethiopia',
    },
    {
        value: '+500',
        label: 'Falkland Islands',
    },
    {
        value: '+298',
        label: 'Faroe Islands',
    },
    {
        value: '+679',
        label: 'Fiji',
    },
    {
        value: '+358',
        label: 'Finland',
    },
    {
        value: '+33',
        label: 'France',
    },
    {
        value: '+594',
        label: 'French Guiana',
    },
    {
        value: '+689',
        label: 'French Polynesia',
    },
    {
        value: '+241',
        label: 'Gabon',
    },
    {
        value: '+220',
        label: 'Gambia',
    },
    {
        value: '+995',
        label: 'Georgia',
    },
    {
        value: '+49',
        label: 'Germany',
    },
    {
        value: '+233',
        label: 'Ghana',
    },
    {
        value: '+350',
        label: 'Gibraltar',
    },
    {
        value: '+30',
        label: 'Greece',
    },
    {
        value: '+299',
        label: 'Greenland',
    },
    {
        value: '+1 473',
        label: 'Grenada',
    },
    {
        value: '+590',
        label: 'Guadeloupe',
    },
    {
        value: '+1 671',
        label: 'Guam',
    },
    {
        value: '+502',
        label: 'Guatemala',
    },
    {
        value: '+224',
        label: 'Guinea',
    },
    {
        value: '+245',
        label: 'Guinea-Bissau',
    },
    {
        value: '+509',
        label: 'Haiti',
    },
    {
        value: '+504',
        label: 'Honduras',
    },
    {
        value: '+852',
        label: 'Hong Kong SAR China',
    },
    {
        value: '+36',
        label: 'Hungary',
    },
    {
        value: '+354',
        label: 'Iceland',
    },
    {
        value: '+91',
        label: 'India',
    },
    {
        value: '+62',
        label: 'Indonesia',
    },
    {
        value: '+98',
        label: 'Iran',
    },
    {
        value: '+964',
        label: 'Iraq',
    },
    {
        value: '+353',
        label: 'Ireland',
    },
    {
        value: '+972',
        label: 'Israel',
    },
    {
        value: '+39',
        label: 'Italy',
    },
    {
        value: '+225',
        label: 'Ivory Coast',
    },
    {
        value: '+1 876',
        label: 'Jamaica',
    },
    {
        value: '+81',
        label: 'Japan',
    },
    {
        value: '+962',
        label: 'Jordan',
    },
    {
        value: '+7 7',
        label: 'Kazakhstan',
    },
    {
        value: '+254',
        label: 'Kenya',
    },
    {
        value: '+686',
        label: 'Kiribati',
    },
    {
        value: '+965',
        label: 'Kuwait',
    },
    {
        value: '+996',
        label: 'Kyrgyzstan',
    },
    {
        value: '+856',
        label: 'Laos',
    },
    {
        value: '+371',
        label: 'Latvia',
    },
    {
        value: '+961',
        label: 'Lebanon',
    },
    {
        value: '+266',
        label: 'Lesotho',
    },
    {
        value: '+231',
        label: 'Liberia',
    },
    {
        value: '+218',
        label: 'Libya',
    },
    {
        value: '+423',
        label: 'Liechtenstein',
    },
    {
        value: '+370',
        label: 'Lithuania',
    },
    {
        value: '+352',
        label: 'Luxembourg',
    },
    {
        value: '+853',
        label: 'Macau SAR China',
    },
    {
        value: '+389',
        label: 'Macedonia',
    },
    {
        value: '+261',
        label: 'Madagascar',
    },
    {
        value: '+265',
        label: 'Malawi',
    },
    {
        value: '+60',
        label: 'Malaysia',
    },
    {
        value: '+960',
        label: 'Maldives',
    },
    {
        value: '+223',
        label: 'Mali',
    },
    {
        value: '+356',
        label: 'Malta',
    },
    {
        value: '+692',
        label: 'Marshall Islands',
    },
    {
        value: '+596',
        label: 'Martinique',
    },
    {
        value: '+222',
        label: 'Mauritania',
    },
    {
        value: '+230',
        label: 'Mauritius',
    },
    {
        value: '+262',
        label: 'Mayotte / Reunion',
    },
    {
        value: '+52',
        label: 'Mexico',
    },
    {
        value: '+691',
        label: 'Micronesia',
    },
    {
        value: '+1 808',
        label: 'Midway Island / Wake Island',
    },
    {
        value: '+373',
        label: 'Moldova',
    },
    {
        value: '+377',
        label: 'Monaco',
    },
    {
        value: '+976',
        label: 'Mongolia',
    },
    {
        value: '+382',
        label: 'Montenegro',
    },
    {
        value: '+1664',
        label: 'Montserrat',
    },
    {
        value: '+212',
        label: 'Morocco',
    },
    {
        value: '+95',
        label: 'Myanmar',
    },
    {
        value: '+264',
        label: 'Namibia',
    },
    {
        value: '+674',
        label: 'Nauru',
    },
    {
        value: '+977',
        label: 'Nepal',
    },
    {
        value: '+31',
        label: 'Netherlands',
    },
    {
        value: '+599',
        label: 'Netherlands Antilles',
    },
    {
        value: '+1 869',
        label: 'Nevis',
    },
    {
        value: '+687',
        label: 'New Caledonia',
    },
    {
        value: '+64',
        label: 'New Zealand',
    },
    {
        value: '+505',
        label: 'Nicaragua',
    },
    {
        value: '+227',
        label: 'Niger',
    },
    {
        value: '+234',
        label: 'Nigeria',
    },
    {
        value: '+683',
        label: 'Niue',
    },
    {
        value: '+850',
        label: 'North Korea',
    },
    {
        value: '+1 670',
        label: 'Northern Mariana Islands',
    },
    {
        value: '+47',
        label: 'Norway',
    },
    {
        value: '+968',
        label: 'Oman',
    },
    {
        value: '+92',
        label: 'Pakistan',
    },
    {
        value: '+680',
        label: 'Palau',
    },
    {
        value: '+970',
        label: 'Palestinian Territory',
    },
    {
        value: '+507',
        label: 'Panama',
    },
    {
        value: '+675',
        label: 'Papua New Guinea',
    },
    {
        value: '+595',
        label: 'Paraguay / Guyana',
    },
    {
        value: '+51',
        label: 'Peru',
    },
    {
        value: '+63',
        label: 'Philippines',
    },
    {
        value: '+48',
        label: 'Poland',
    },
    {
        value: '+351',
        label: 'Portugal',
    },
    {
        value: '+1 787',
        label: 'Puerto Rico',
    },
    {
        value: '+974',
        label: 'Qatar',
    },
    {
        value: '+40',
        label: 'Romania',
    },
    {
        value: '+7',
        label: 'Russia',
    },
    {
        value: '+250',
        label: 'Rwanda',
    },
    {
        value: '+685',
        label: 'Samoa',
    },
    {
        value: '+378',
        label: 'San Marino',
    },
    {
        value: '+966',
        label: 'Saudi Arabia',
    },
    {
        value: '+221',
        label: 'Senegal',
    },
    {
        value: '+381',
        label: 'Serbia',
    },
    {
        value: '+248',
        label: 'Seychelles',
    },
    {
        value: '+232',
        label: 'Sierra Leone',
    },
    {
        value: '+65',
        label: 'Singapore',
    },
    {
        value: '+421',
        label: 'Slovakia',
    },
    {
        value: '+386',
        label: 'Slovenia',
    },
    {
        value: '+677',
        label: 'Solomon Islands',
    },
    {
        value: '+27',
        label: 'South Africa',
    },
    {
        value: '+82',
        label: 'South Korea',
    },
    {
        value: '+34',
        label: 'Spain',
    },
    {
        value: '+94',
        label: 'Sri Lanka',
    },
    {
        value: '+249',
        label: 'Sudan',
    },
    {
        value: '+597',
        label: 'Suriname',
    },
    {
        value: '+268',
        label: 'Swaziland',
    },
    {
        value: '+46',
        label: 'Sweden',
    },
    {
        value: '+41',
        label: 'Switzerland',
    },
    {
        value: '+963',
        label: 'Syria',
    },
    {
        value: '+886',
        label: 'Taiwan',
    },
    {
        value: '+992',
        label: 'Tajikistan',
    },
    {
        value: '+255',
        label: 'Tanzania / Zanzibar',
    },
    {
        value: '+66',
        label: 'Thailand',
    },
    {
        value: '+670',
        label: 'Timor Leste / East Timor',
    },
    {
        value: '+228',
        label: 'Togo',
    },
    {
        value: '+690',
        label: 'Tokelau',
    },
    {
        value: '+676',
        label: 'Tonga',
    },
    {
        value: '+1 868',
        label: 'Trinidad and Tobago',
    },
    {
        value: '+216',
        label: 'Tunisia',
    },
    {
        value: '+90',
        label: 'Turkey',
    },
    {
        value: '+993',
        label: 'Turkmenistan',
    },
    {
        value: '+1 649',
        label: 'Turks and Caicos Islands',
    },
    {
        value: '+688',
        label: 'Tuvalu',
    },
    {
        value: '+1 340',
        label: 'U.S. Virgin Islands',
    },
    {
        value: '+256',
        label: 'Uganda',
    },
    {
        value: '+380',
        label: 'Ukraine',
    },
    {
        value: '+971',
        label: 'United Arab Emirates',
    },
    {
        value: '+44',
        label: 'United Kingdom',
    },
    {
        value: '+1',
        label: 'United States / Canada',
    },
    {
        value: '+598',
        label: 'Uruguay',
    },
    {
        value: '+998',
        label: 'Uzbekistan',
    },
    {
        value: '+678',
        label: 'Vanuatu',
    },
    {
        value: '+58',
        label: 'Venezuela',
    },
    {
        value: '+84',
        label: 'Vietnam',
    },
    {
        value: '+681',
        label: 'Wallis and Futuna',
    },
    {
        value: '+967',
        label: 'Yemen',
    },
    {
        value: '+260',
        label: 'Zambia',
    },
    {
        value: '+263',
        label: 'Zimbabwe',
    },
];

const MAPPED_PHONE_CODE = COUNTRIES_PHONE_CODE.map(country => ({ value: country.value, label: `${country.label} (${country.value})` }));
const EMIRATE_LIST_CARD = [{
        value: 'Abu Dhabi',
        label: 'Abu Dhabi',
    },
    {
        value: 'Dubai',
        label: 'Dubai',
    },
    {
        value: 'Sharjah',
        label: 'Sharjah',
    },
    {
        value: 'Ajman',
        label: 'Ajman',
    },
    {
        value: 'Umm Al Quwain',
        label: 'Umm Al Quwain',
    },
    {
        value: 'Ras Al Khaimah',
        label: 'Ras Al Khaimah',
    },
    {
        value: 'Fujairah',
        label: 'Fujairah',
    },
    {
        value: 'Al Ain',
        label: 'Al Ain',
    },
    {
        value: 'Sajja',
        label: 'Sajja',
    },
];
const EMIRATE_LIST = [{
        value: 'Abu Dhabi',
        label: 'Abu Dhabi',
    },
    {
        value: 'Dubai',
        label: 'Dubai',
    },
    {
        value: 'Sharjah',
        label: 'Sharjah',
    },
    {
        value: 'Ajman',
        label: 'Ajman',
    },
    {
        value: 'Umm Al Quwain',
        label: 'Umm Al Quwain',
    },
    {
        value: 'Ras Al Khaimah',
        label: 'Ras Al Khaimah',
    },
    {
        value: 'Fujairah',
        label: 'Fujairah',
    },
];
const MONTHLY_INSTALMENTS_OPTIONS = [{
        value: 'The 1st day of each month',
        label: 'The 1st day of each month',
    },
    {
        value: 'The 2nd day of each month',
        label: 'The 2nd day of each month',
    },
    {
        value: 'The 3rd day of each month',
        label: 'The 3rd day of each month',
    },
    {
        value: 'The 4th day of each month',
        label: 'The 4th day of each month',
    },
    {
        value: 'The 5th day of each month',
        label: 'The 5th day of each month',
    },
    {
        value: 'The 10th day of each month',
        label: 'The 10th day of each month',
    },
    {
        value: 'The 12th day of each month',
        label: 'The 12th day of each month',
    },
    {
        value: 'The 15th day of each month',
        label: 'The 15th day of each month',
    },
    {
        value: 'The 27th day of each month',
        label: 'The 27th day of each month',
    },
    {
        value: 'The 28th day of each month',
        label: 'The 28th day of each month',
    },
    {
        value: 'The 29th day of each month',
        label: 'The 29th day of each month',
    },
]
const INDUSTRY_TYPES = [
        { value: 'Agriculture, hunting and forestry', label: 'Agriculture, hunting and forestry' },
        { value: 'Airlines', label: 'Airlines' },
        { value: 'Automotive', label: 'Automotive' },
        { value: 'Banks', label: 'Banks' },
        { value: 'Construction', label: 'Construction' },
        { value: 'Contracting services', label: 'Contracting services' },
        { value: 'Distributor / wholesaler', label: 'Distributor / wholesaler' },
        { value: 'Education institutions (e.g. schools, college)', label: 'Education institutions (e.g. schools, college)' },
        { value: 'Embassies / Consulates', label: 'Embassies / Consulates' },
        { value: 'Employed by private individual', label: 'Employed by private individual' },
        { value: 'Finance companies', label: 'Finance companies' },
        { value: 'Fishing', label: 'Fishing' },
        { value: 'Government - Public administration / Ministry', label: 'Government - Public administration / Ministry' },
        { value: 'Hospital and clinics', label: 'Hospital and clinics' },
        { value: 'Hotels/ restaurants / clubs', label: 'Hotels/ restaurants / clubs' },
        { value: 'Import / Export', label: 'Import / Export' },
        { value: 'Information technologies', label: 'Information technologies' },
        { value: 'Insurance companies', label: 'Insurance companies' },
        { value: 'Manufacturing', label: 'Manufacturing' },
        { value: 'Entertainment', label: 'Entertainment' },
        { value: 'Mining and quarrying', label: 'Mining and quarrying' },
        { value: 'NGO / cultural organizations', label: 'NGO / cultural organizations' },
        { value: 'Oil and Gas', label: 'Oil and Gas' },
        { value: 'Others', label: 'Others' },
        { value: 'Police / military', label: 'Police / military' },
        { value: 'Professional services (e.g. Architect)', label: 'Professional services (e.g. Architect)' },
        { value: 'Real estate, renting and business activities', label: 'Real estate, renting and business activities' },
        { value: 'Retailing', label: 'Retailing' },
        { value: 'Services (e.g. Tailor, Barber, etc.)', label: 'Services (e.g. Tailor, Barber, etc.)' },
        { value: 'Telecom', label: 'Telecom' },
        { value: 'Training institute / Polytechnics / Voca', label: 'Training institute / Polytechnics / Voca' },
        { value: 'Transport and shipping', label: 'Transport and shipping' },
        { value: 'Travel and tourism (includes car rentals)', label: 'Travel and tourism (includes car rentals)' },
        { value: 'Utilities', label: 'Utilities' },
        { value: 'Lawyers and Legal firms', label: 'Lawyers and Legal firms' },
        { value: 'Journalist/ Media and Publishing', label: 'Journalist/ Media and Publishing' },
        { value: 'Typing Centers', label: 'Typing Centers' },
    ]
    // OTP LOGIC CONSTANTS
const NOT_VALID_OTP_MESSAGE = 'The OTP verification has failed.';

// UPLOAD LOGIC
const RESET_UPLOADS_BUTTON = 'Change files';

const STEP_HOOK_BLOCKER = 'STEP_HOOK_BLOCKER';

export {
    // GENERIC EXPORTS
    GENERIC_TITLE,
    GENERIC_SUBTITLE,
    GENERIC_LOADING_MESSAGE,
    NOT_ELIGIBLE,
    ELIGIBLE,
    CREDIT_NOT_APPROVED_TITLE,
    NOT_ELIGIBLE_MESSAGE,
    NO_MONTHLY_INSTALMENTS_FROM_SERVER,
    TRANSACTION_NOT_STARTED,
    END_FORM,
    // LONG VALUES
    COUNTRIES,
    COUNTRIESAPPOINTMENT,
    EMIRATE_LIST,
    EMIRATE_LIST_CARD,
    MAPPED_PHONE_CODE,
    // AGE EXPORTS
    MIN_AGE,
    MAX_AGE,
    END_PAGE_OPS,
    NOT_VALID_AGE_MESSAGE,
    NOT_VALID_INCOME_MESSAGE,
    MIN_TOTAL_INCOME,
    MIN_FIXED_INCOME_DSP,
    MAX_ALLOWED,
    MIN_ALLOWED,
    // PATTERN EXPORTS
    EMAIL_VALIDATION_PATTERN,
    MOBILE_STARTING_NUMBER,
    MOBILE_NUMBER_LENGTH,
    MOBILE_NUMBER_LENGTH_GLOBAL,
    IBAN_NUMBER_LENGTH,
    DIGIT_CHARS,
    NAMES_CHARS,
    NAME_CHARS_SPACE,
    EMIRATES_STARTING_NUMBER,
    EMIRATES_NUMBER_LENGTH,
    ALPHA_NUMERIC,
    IS_VALID_DATE,
    CREDIT_CARD_NUMBER_LENGTH,
    SUPPLEMENTARY_CHARS,
    SUPPLEMENTARY_PERCENTAGE,
    // FIELDS BY NAME EXPORTS
    NOT_VALID_OTP_MESSAGE,
    MOBILE_NUMBER_FIELD_NAME,
    RESET_UPLOADS_BUTTON,
    STEP_HOOK_BLOCKER,
    AT_MY_OFFICE,
    SOMEWHERE_ELSE,
    APPOINTMENT_PLACE_OPTIONS,
    // DBR
    MIN_ALLOWED_DBR,
    DBR_CARD_LIMIT_PERCENT,
    // DOUBLE SECURE
    NOMINEE_RELATIONSHIP_OPTIONS,
    // DECISION SERVICE
    APPROVED,
    REJECTED,
    CONDITIONALLY_APPROVED,
    DECISION_FORM_MAP,
    BASIC_NOT_ELIGIBLE,
    TECHNICAL_ERROR,
    MONTHLY_INSTALMENTS_OPTIONS,
    INDUSTRY_TYPES,
    CREDIT_NOT_APPROVED_TITLE_SALES,
    NOT_ELIGIBLE_MESSAGE_SALES,
    MIN_FIXED_INCOME,
    CAPTCHA_CHARS,
    CAPTCHA_LENGTH,
    MIN_TOTAL_INCOME_LOAN,
    ADDRESS_CHARS,
    COUNTRIES_HIGH_RISK
    //REJECTED_BUREAU_SCORE,
};